// extracted by mini-css-extract-plugin
export var productImage = "_n8-0";